var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-switch=\"mode\"><div ng-switch-when=\"edit\"><h4 ng-bind-html=\"field_label | to_trusted\"></h4><input type=\"text\" name=\"{{field.name}}\" ng-required=\"field.required\" ng-model=\"field.value\" class=\"form-control phone-input\"></div><div ng-switch-when=\"view\"><div ng-class=\"{white: (index + 1) % 2 == 0}\" class=\"colorcont clearfix\"><div class=\"left disable\"><p ng-bind-html=\"field.label | to_trusted\"></p></div><div class=\"right\"><p>{{field.value}}</p></div></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/phone/phone.jade
// module id = 389
// module chunks = 0